import React from 'react'
import '../../../styles/dashboard/WelcomeBanner.css'

const BannerSkeleton = () => {
    return (
        <div className="welcome-banner-container animate-pulse flex items-center">
            <div className="w-full">
                <div className="absolute bottom-[15px] left-[40px] bg-aquaPulse rounded-full" style={{ width: 90, height: 80, opacity: 0.5 }} />
                <div className="w-full pl-[30%] sm:pl-[20%] items-start flex flex-col justify-center gap-[10px]">
                    <div className="h-6 bg-lightBG rounded w-[60%] mb-2 opacity-50"></div>
                    <div className="h-4 bg-lightBG rounded w-1/2 opacity-50"></div>
                </div>
            </div>
        </div>
    )
}

export default BannerSkeleton
